import { useRouter } from "vue-router";
export class Navigation {
    router = useRouter();
    toRouteName(name, params = {}, query = {}) {
        return this.router.push({ name: name, params: params, query: query });
    }
    goBack() {
        this.router.go(-1);
    }
}
